import styled from 'styled-components';

export const ButtonContainer = styled.div`
  display: flex;
  margin-top: 1rem;
  flex-direction: row-reverse;
`;
